module.exports = __webpack_public_path__ + "img/cheers.8c1f4abe.png";